export class TokensQueryV2Model {
  captchaResponse: string;
}
